import { useState } from "react";
import { useLoaderData } from "react-router-dom";
import { MyDocumentPageLoaderType } from "src/pages/MyDocumentPage/loaders";
import { Button, Card } from "antd";
import { S3ServiceLambda } from "~/services/s3";
import { FileData } from "~/types";
import { useAppTranslation } from "~/hooks/useAppTranslation";

export const ListFiles = () => {
  const loaderData = useLoaderData() as MyDocumentPageLoaderType;
  const { t } = useAppTranslation();
  const [listCurrentFiles, setListCurrentFiles] = useState<FileData[] | null>(
    loaderData.fileList
  );

  const deleting = async (currentFile: FileData) => {
    try {
      if (currentFile.name.length !== 0 && currentFile.name !== null) {
        alert(
          (await S3ServiceLambda.remove({ key: currentFile.key })).success
        );
        if (listCurrentFiles !== null) {
          setListCurrentFiles(
            listCurrentFiles.filter((a) => a.key !== currentFile.key)
          );
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {listCurrentFiles?.map((item) => {
        return (
          <Card type="inner" title={item.name}>
            <Button href={item.url} target="_blank" rel="noopener noreferrer">
              {t("View_More")}
            </Button>
            <Button
              onClick={() => deleting(item)}
              style={{ marginLeft: "10px" }}
            >
              {t("Delete_File")}
            </Button>
          </Card>
        );
      })}
    </>
  );
};
